export default [
  {
    path: '/ibd',
    component: () => import('./views/index')
  },
  {
    path: '/ibd/teams',
    component: () => import('./views/teams')
  },
  {
    path: '/ibd/docs',
    component: () => import('./views/docs')
  },
  {
    path: '/ibd/preapply',// 预约住院首页
    component: () => import('./views/preapply')
  },
  {
    path: '/ibd/choose',// 咨询专家页
    component: () => import('./views/choose')
  },

  {
    path: '/ibd/apply',// 申请预约住院
    component: () => import('./views/apply')
  },

  {
    path: '/ibd/order/list', // 预约记录
    component: () => import('./views/order/list')
  },

  {
    path: '/ibd/order/detail',// 预约记录详情
    component: () => import('./views/order/detail')
  },

  {
    path: '/ibd/order/info',// 预约记录资料
    component: () => import('./views/order/info')
  },

  {
    path: '/ibd/news',// 用药宣教
    component: () => import('./views/news')
  },

  {
    path: '/ibd/news/detail',//  宣教详情
    component: () => import('./views/news/detail')
  },

  {
    path: '/ibd/news/search',// 宣教搜索
    component: () => import('./views/news/search')
  },

  {
    path: '/ibd/followup',// 健康随访
    component: () => import('./views/followup')
  },

  {
    path: '/ibd/paper',// 健康随访问卷
    component: () => import('./views/paper')
  },
]



// WEBPACK FOOTER //
// ./src/page/ibd/ibdRoute.js